import get from 'lodash/get';

import { formatWorkspaceType } from 'Shared/helpers';

import { getItemByUuid, getItemAttachments } from './workspace';
import {
  getMeetingItemByUuid as getMeetingItemByUuidSelector,
  getMeetingItemAttachments as getMeetingItemAttachmentsSelector,
} from './meetingItems';

function formatWorkspaceMembers({ workspaceMembers, currentUserId }) {
  return workspaceMembers.map(member => {
    let mentionEntryName;
    const isCurrentUser = currentUserId === member.id;

    if (currentUserId === member.id) mentionEntryName = `You - ${member.email}`;
    else mentionEntryName = member.fullName ? `${member.fullName} - ${member.email}` : member.email;

    const mentionLinkLabel = member.fullName || member.email;
    const mentionFullInfo = member.fullName ? `${member.fullName} (${member.email})` : member.email;
    return {
      id: member.personId,
      email: member.email,
      // 'name' used for showing label of choosing mention
      name: mentionLinkLabel,
      // 'mentionEntryName' used for showing label of item in dropdown mention
      mentionEntryName,
      // 'mentionFullInfo' used for showing tooltip for link
      mentionFullInfo,
      isCurrentUser,
      global_id: `person:${member.personId}`,
      label: mentionEntryName,
      value: member.personId.toString(),
      isWorkspaceMember: true,
      avatar: member.avatar,
      userId: member.id,
    };
  });
}

export const getMeetingItemByUuid = itemUuid => state => {
  return getMeetingItemByUuidSelector(itemUuid)(state) || getItemByUuid(itemUuid)(state);
};

export const getWorkspaceMembersMentionsByWorkspaceId = workspaceId => state => {
  const currentUserId = state.user.id;
  if (!workspaceId) {
    return formatWorkspaceMembers({
      workspaceMembers: state.workspace.users || [],
      currentUserId,
    });
  }

  const { workspaces } = state;
  const workspaceMembers = get(
    workspaces.find(({ id }) => id === workspaceId),
    'users',
    []
  );
  const workspaceMembersMentions = formatWorkspaceMembers({ workspaceMembers, currentUserId });
  return workspaceMembersMentions;
};

export const getWorkspaceMembersMentions = meetingItemUuid => state => {
  let workspaceId = null;
  if (meetingItemUuid) {
    const meetingItem = getMeetingItemByUuid(meetingItemUuid)(state);
    workspaceId = meetingItem.workspaceId;
  }

  return getWorkspaceMembersMentionsByWorkspaceId(workspaceId)(state);
};

export const getCurrentWorkspaceType = () => state => {
  return formatWorkspaceType(state.workspace);
};

export const getWorkspaceType = meetingItemUuid => state => {
  if (!meetingItemUuid) return formatWorkspaceType(state.workspace);
  const meetingItem = getMeetingItemByUuid(meetingItemUuid)(state);
  if (!meetingItem) return null;
  const { workspaceId } = meetingItem;
  const { workspaces } = state;
  return formatWorkspaceType(workspaces.find(({ id }) => id === workspaceId));
};

export const getMeetingItemAttachments = itemUuid => state => {
  const itemAttachments = getItemAttachments(itemUuid)(state);
  if (itemAttachments.length) return itemAttachments;
  return getMeetingItemAttachmentsSelector(itemUuid)(state);
};
